export type SwayyShipmentStatus =
  | "created"
  | "picked_up"
  | "in_transit"
  | "out_for_delivery"
  | "delivered"
  | "failed_delivery"
  | "rto_initiated"
  | "rto_delivered";

export interface SwayyShipmentItem {
  id?: number;
  order_item_id: number;
  qty: number;
  sku: string;
  name: string;
  variant_label?: string | null;
}

export interface SwayyShipmentInvoiceRef {
  id: number;
  status: string;
}

export interface SwayyShipment {
  id: number;
  shipment_number?: string | null;
  order_id: number;
  order_number?: string | null;
  warehouse_id?: number | null;
  carrier_id?: number | null;
  carrier?: string | null;
  awb?: string | null;
  tracking_url?: string | null;
  status: SwayyShipmentStatus | string;
  shipped_at?: string | null;
  expected_at?: string | null;
  delivered_at?: string | null;
  created_at?: string;
  updated_at?: string;
  items: SwayyShipmentItem[];
  invoice?: SwayyShipmentInvoiceRef | null;
}

export interface SwayyShipmentsPagination {
  total: number;
  page: number;
  limit: number;
}

export interface SwayyShipmentsListData {
  shipments: SwayyShipment[];
  pagination: SwayyShipmentsPagination;
}

export interface GetSwayyShipmentsParams {
  page: number;
  limit: number;
  status?: string;
  carrier_id?: number | string;
  warehouse_id?: number | string;
  awb?: string;
  from_date?: string;
  to_date?: string;
  overdue?: boolean | "";
}

export interface CreateSwayyShipmentItemInput {
  order_item_id: number;
  qty: number;
}

export type SwayyCourierPartner = "shiprocket" | "shipmozo";

export interface CreateSwayyShipmentPayload {
  warehouse_id: number;
  expected_at: string;
  items: CreateSwayyShipmentItemInput[];
  carrier_id: number;
  courier?: SwayyCourierPartner;
  awb?: string | null;
  tracking_url?: string | null;
}

export interface UpdateSwayyShipmentPayload {
  status?: SwayyShipmentStatus | string;
  carrier_id?: number | null;
  awb?: string | null;
  tracking_url?: string | null;
  expected_at?: string | null;
}

export interface SwayyShipmentInventoryMovement {
  id: number;
  variant_id: number;
  warehouse_id: number;
  movement_type: string;
  qty_on_hand: number;
  qty_reserved: number;
  order_id?: number | null;
  order_item_id?: number | null;
  shipment_id?: number | null;
  reason?: string | null;
  actor_type?: string | null;
  actor_id?: number | null;
  created_at?: string;
}

export interface SwayyShipmentAuditDetails {
  order_id?: number;
  carrier_id?: number | null;
  awb?: string | null;
  items?: Array<{ qty?: number; order_item_id?: number }>;
  diff?: Record<string, { from?: unknown; to?: unknown }>;
  [key: string]: unknown;
}

export interface SwayyShipmentAuditEvent {
  id: number;
  actor_type?: string | null;
  actor_admin_id?: number | null;
  action: string;
  entity_type?: string | null;
  entity_id?: number | null;
  status?: string | null;
  details?: SwayyShipmentAuditDetails | null;
  created_at?: string;
}

export interface SwayyShipmentFullDetail {
  shipment: SwayyShipment;
  inventory_movements: SwayyShipmentInventoryMovement[];
  audit_trail: SwayyShipmentAuditEvent[];
}

export const getSwayyShipmentNumber = (shipment: {
  shipment_number?: string | null;
}): string => {
  const value = String(shipment.shipment_number ?? "").trim();
  if (!value || value.toLowerCase() === "null") return "";
  return value;
};
